export default (props) => {
  const { color, width, height } = props;
  const colorInput = color || "#1AAE6F";
  const widthInput = width || 16;
  const heightInput = height || 16;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={widthInput}
      height={heightInput}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M0 8C0 3.59375 3.5625 0 8 0C12.4063 0 16 3.59375 16 8C16 12.4375 12.4063 16 8 16C3.5625 16 0 12.4375 0 8ZM11.5938 6.625C11.9375 6.28125 11.9375 5.75 11.5938 5.40625C11.25 5.0625 10.7188 5.0625 10.375 5.40625L7 8.78125L5.59375 7.40625C5.25 7.0625 4.71875 7.0625 4.375 7.40625C4.03125 7.75 4.03125 8.28125 4.375 8.625L6.375 10.625C6.71875 10.9688 7.25 10.9688 7.59375 10.625L11.5938 6.625Z"
        fill={colorInput}
      />
    </svg>
  );
};
